import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted, watch } from 'vue'
import Vessels from './Vessels.vue'
import Cable from './Cable.vue'
import { CableClient, MapCableDataPoint, CableVessel } from '@/server/MakeSenseApp-backend'
import { useProjectStore } from '@/stores/ProjectStore'
import { requiredInject } from '@/utilities/requiredInject'


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalMap',
  props: {
  vessel: {
    type: CableVessel,
    required: true
  }
},
  setup(__props) {

var projectStore = useProjectStore()

const projection = ref('EPSG:3857')
const zoom = ref(9)
const center = ref([0, 0])

const cable = ref<MapCableDataPoint[]>([])

var props = __props

watch(
  () => props.vessel,
  () => {
    center.value = [props.vessel?.easting ?? 0, props.vessel?.northing ?? 0]
  },
  { immediate: true }
)

onMounted(() => {
  watch(
    () => projectStore.projectId,
    () => {
      var cableClient = requiredInject<CableClient>('CableClient')
      cableClient.cable(projectStore.projectId, null).then((cablePoints) => {
        cable.value = cablePoints
      })
    },
    { immediate: true }
  )
})

return (_ctx: any,_cache: any) => {
  const _component_ol_view = _resolveComponent("ol-view")!
  const _component_ol_source_osm = _resolveComponent("ol-source-osm")!
  const _component_ol_tile_layer = _resolveComponent("ol-tile-layer")!
  const _component_ol_map = _resolveComponent("ol-map")!

  return (_openBlock(), _createBlock(_component_ol_map, {
    controls: [],
    projection: projection.value
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ol_view, {
        center: center.value,
        zoom: zoom.value,
        projection: projection.value
      }, null, 8, ["center", "zoom", "projection"]),
      _createVNode(_component_ol_tile_layer, { className: "dts-background-map" }, {
        default: _withCtx(() => [
          _createVNode(_component_ol_source_osm)
        ]),
        _: 1
      }),
      _createVNode(Vessels, {
        isVisible: true,
        vesselData: [__props.vessel]
      }, null, 8, ["vesselData"]),
      _createVNode(Cable, {
        sensorReadings: cable.value,
        isVisible: true
      }, null, 8, ["sensorReadings"])
    ]),
    _: 1
  }, 8, ["projection"]))
}
}

})